import Image from '../../store-components/Image/Image';
import type { ImagesSchema } from './@types/StoreImageListProps';

export const getImagesAsJSXList = (
	images: ImagesSchema,
	isMobile: boolean,
	height: string | number,
	preload?: boolean,
	blockClass?: string,
) => {
	return images.map(
		({ image, mobileImage, description, experimentalPreventLayoutShift, width = '100%', ...props }, idx) => (
			<Image
				key={idx}
				src={isMobile && mobileImage ? mobileImage : image}
				alt={description}
				maxHeight={height}
				width={width}
				preload={preload && idx === 0}
				{...props}
				blockClass={blockClass}
			/>
		),
	);
};
